<template>
  <ion-button
    class="m-0 app-button"
    expand="block"
    shape="round"
    :disabled="disabled"
    :color="['primary', 'secondary'].includes(type) ? 'primary' : type"
    :fill="type === 'primary' ? 'solid' : 'outline'"
    @click="$emit('click')"
  >
    <div
      class="relative w-full flex items-center justify-center"
      :class="{
        'text-black': darkText,
      }"
    >
      <div v-if="!loading">
        {{ text }}
      </div>
      <ion-spinner
        v-if="loading"
        class="absolute"
        :class="{
          'text-white': type === 'primary',
          'text-primary': type === 'secondary',
        }"
        aria-hidden="true"
      />
      <ion-icon
        v-else-if="!loading && icon"
        class="absolute right-0 text-accent"
        aria-hidden="true"
        :icon="icon"
      />
    </div>
  </ion-button>
</template>

<script setup lang="ts">
import { IonIcon, IonButton, IonSpinner } from '@ionic/vue';
import { useUserStore } from '@/store/user';
import { storeToRefs } from 'pinia';

defineEmits<{
  (e: 'click'): void;
}>();

defineProps<{
  text: string;
  icon?: string;
  loading?: boolean;
  disabled?: boolean;
  type: 'primary' | 'secondary' | 'warning' | 'light' | string;
}>();

const userStore = useUserStore();
const { darkText } = storeToRefs(userStore);

</script>
<style scoped>
:deep(.app-button) {
  --border-radius: 9999px;
  overflow: visible;
}

:deep(.app-button::part(native)) {
  border-radius: var(--border-radius);
  overflow: visible;
}
</style>
